var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{class:_vm.$style['mdc-carousel-item'],style:({
        width: _vm.width
    })},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }